import { render } from "./SetElectricityCost.vue?vue&type=template&id=2704ecd6&scoped=true"
import script from "./SetElectricityCost.vue?vue&type=script&lang=js"
export * from "./SetElectricityCost.vue?vue&type=script&lang=js"

import "./SetElectricityCost.vue?vue&type=style&index=0&id=2704ecd6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2704ecd6"]])

export default __exports__